import { BasicoApi } from '@common/api';

const ServicoInstrumentoService = {
  listarServicos: function (parametros) {
    return BasicoApi.get()('/ServicoInstrumento/servico', parametros);
  },
  excluirServico: function (parametros) {
    return BasicoApi.delete()(`/ServicoInstrumento`, parametros);
  },
  salvarServico: function (servicoId) {
    return BasicoApi.post()('/ServicoInstrumento', servicoId);
  },
  listarServicosModal: function (parametros) {
    return BasicoApi.get()('/ServicoInstrumento/servico/listagem-modal', parametros);
  },
  listarPecas: function (parametros) {
    return BasicoApi.get()('/ServicoInstrumento/item', parametros);
  },
  excluirPecas: function (parametros) {
    return BasicoApi.delete()(`/ServicoInstrumento/item`, parametros);
  },
  salvarPecas: function (servicoId) {
    return BasicoApi.post()('/ServicoInstrumento/item', servicoId);
  },
  listarPecasModal: function (parametros) {
    return BasicoApi.get()('/ServicoInstrumento/item/listagem-modal', parametros);
  },
};

export default ServicoInstrumentoService;
